import { createContext } from 'react';

// True while a nav item is rendered inside TopNavBar's stacked mobile menu
// (the hamburger panel) rather than the desktop bar. NavDropdown reads it to
// open its sub-menu IN the flow, as an accordion under its own button,
// instead of as a floating absolute box — which, inside the mobile panel's
// scroll container, sat on top of the items below it and had to be scrolled
// to be seen.
export const NavInlineContext = createContext(false);
